// extracted by mini-css-extract-plugin
module.exports = {"left":"leftsidecomponent-module--left--39pyd","children":"leftsidecomponent-module--children--3JOXP"};